import settings from '../config/settings'
import { User } from './User'

const methods = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE'
}

const getHeaders = () => {
  const jwt = User.getToken()
  const headerAuth = `${jwt.tokenType} ${jwt.accessToken}`
  return {
    'Content-Type': 'application/json',
    Authorization: headerAuth
  }
}

const parseJSON = response => {
  return response
    .text()
    .then(text => {
      try {
        return text
          ? JSON.parse(text)
          : {}
      } catch (error) {
        throw new Error(error)
      }
    })
    .catch(error => console.error(error))
}

export type ApiType = 'mainApi' | 'userApi' | 'videoProcessingApi' | 'statsApi' | 'actionHistoryApi' | 'marketPlaceApi'

export class Api {
  static put<ResultType = unknown, BodyType = object> (url: string, body: BodyType, apiType: ApiType = 'mainApi') {
    let response = { ok: true, status: 200 }
    const api = settings[apiType]

    return new Promise<ResultType>((resolve, reject) => {
      window.fetch(
        `${api}${url}`,
        {
          method: methods.PUT,
          headers: getHeaders(),
          body: JSON.stringify(body)
        }
      )
        .then(res => {
          response = { ok: res.ok, status: res.status }
          return parseJSON(res)
        })
        .then((resBody: any) => {
          // console.log('POST RESPONSE:', resBody);
          return response.ok
            ? resolve(resBody)
            : reject(new Error(JSON.stringify({ ...resBody, ...response })))
        }
        )
        .catch(err => reject(err))
    })
  }

  static post<ResultType = unknown, BodyType = object> (url: string, body: BodyType, apiType: ApiType = 'mainApi', config: RequestInit = {}) {
    let response = { ok: true, status: 200 }
    const api = settings[apiType]

    return new Promise<ResultType>((resolve, reject) => {
      window.fetch(
        `${api}${url}`,
        {
          method: methods.POST,
          headers: getHeaders(),
          body: JSON.stringify(body),
          ...config
        }
      )
        .then(res => {
          response = { ok: res.ok, status: res.status }
          return parseJSON(res)
        })
        .then((resBody: any) => {
          // console.log('POST RESPONSE:', resBody)
          // console.log('response:', response)
          return response.ok
            ? resolve(resBody)
            : reject(new Error(JSON.stringify({ ...resBody, ...response })))
        }
        )
        .catch(err => {
          reject(err)
        })
    })
  }

  static get<ResultType = unknown> (url: string, apiType: ApiType = 'mainApi', config: RequestInit = {}) {
    let response = { ok: true, status: 200 }
    const api = settings[apiType]

    return new Promise<ResultType>((resolve, reject) => {
      window.fetch(
        `${api}${url}`,
        {
          method: methods.GET,
          headers: getHeaders(),
          ...config
        }
      )
        .then(res => {
          response = { ok: res.ok, status: res.status }
          return parseJSON(res)
        })
        .then((resBody: any) => {
          // console.log('GET RESPONSE:', resBody);
          return response.ok
            ? resolve(resBody)
            : reject(new Error(JSON.stringify({ ...resBody, ...response })))
        }
        )
        .catch(reject)
    })
  }

  static delete<ResultType = unknown> (url: string, apiType: ApiType = 'mainApi') {
    let response = { ok: true, status: 200 }
    const api = settings[apiType]

    return new Promise<ResultType>((resolve, reject) => {
      window.fetch(
        `${api}${url}`,
        {
          method: methods.DELETE,
          headers: getHeaders()
        }
      )
        .then(res => {
          response = { ok: res.ok, status: res.status }
          return parseJSON(res)
        })
        .then((resBody: any) => {
          // console.log('GET RESPONSE:', resBody);
          return response.ok
            ? resolve(resBody)
            : reject(new Error(JSON.stringify({ ...resBody, ...response })))
        }
        )
        .catch(reject)
    })
  }
}
